// Import SiteHeader CSS styling

import styles from "./SiteHeader.module.css";

// SiteHeader function component
function SiteHeader() {
  return <div className={styles.wrapper}>React App</div>;
}

export default SiteHeader;
